// OfficerView.js

import { updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";
import calculatePreQualification from "./PreQual";
import calculateRefinancePreQual from "./PreQualRefi";
import { toNum, formatCurrency } from "./formUtils";
import { getAllFormSummaryFields } from "./formUtils";
import { formatPhoneNumber } from "./formUtils";
import LanguageToggle from "./LanguageToggle";

export default function OfficerView() {
  const location = useLocation();
  const navigate = useNavigate();
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const [selectedView, setSelectedView] = useState("Purchase");

  const [purchasePreQual, setPurchasePreQual] = useState(null);
  const [refiPreQual, setRefiPreQual] = useState(null);

  const queryParams = new URLSearchParams(location.search);
  const clientId = queryParams.get("id");

  const [noteToClient, setNoteToClient] = useState("");

  const [officerInfo, setOfficerInfo] = useState(null);

  const officerEmail =
    localStorage.getItem("officerEmail") ||
    new URLSearchParams(window.location.search).get("officerId");

  useEffect(() => {
    if (!officerEmail) return;
    const fetchOfficerInfo = async () => {
      const ref = doc(db, "officers", officerEmail);
      const snap = await getDoc(ref);
      if (snap.exists()) setOfficerInfo(snap.data());
    };
    fetchOfficerInfo();
  }, [officerEmail]);

  const officerName = officerInfo?.name || "Officer";

  const fetchClient = async () => {
    try {
      const ref = doc(db, "clients", clientId);
      const snap = await getDoc(ref);

      if (snap.exists()) {
        const data = snap.data();
        setClientData(data);
        setNoteToClient(data.lastNoteToClient || "");

        if (data.formDataPurchase) {
          const prequal = calculatePreQualification(data.formDataPurchase);
          setPurchasePreQual(prequal);
        } else {
          setPurchasePreQual(null);
        }

        if (data.formDataRefinance) {
          const prequal = calculateRefinancePreQual(data.formDataRefinance);
          setRefiPreQual(prequal);
        } else {
          setRefiPreQual(null);
        }
      } else {
        console.error("Client not found.");
      }
    } catch (err) {
      console.error("Failed to fetch client:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientId) fetchClient();
  }, [clientId]);

  const handleBack = () => {
    navigate("/es/officer-dashboard");
  };

  const handleRefresh = () => {
    fetchClient();
  };

  const currentFormData =
    selectedView === "Purchase"
      ? clientData?.formDataPurchase
      : clientData?.formDataRefinance;

  const currentResult =
    selectedView === "Purchase" ? purchasePreQual : refiPreQual;

  const renderSection = (formData, title, spouse = false) => {
    if (!formData) return null;

    const fields = spouse
      ? [
          [
            "Cónyuge",
            `${currentFormData.spouseFirstName || ""} ${
              currentFormData.spouseLastName || ""
            }`,
          ],
          ["Email Cónyuge", currentFormData.spouseEmail],
          ["Teléfono cónyuge", formatPhoneNumber(currentFormData.spousePhone)],
          [
            "Ingreso",
            toNum(currentFormData?.spouseIncome)
              ? `Mensual ${formatCurrency(toNum(currentFormData.spouseIncome))}`
              : "Mensual N/A",
          ],
          ["Tipo de empleo", currentFormData.spouseEmploymentType],
        ]
      : [
          ["Nomre", currentFormData.firstName],
          ["Apellidos", currentFormData.lastName],
          ["Email", currentFormData.email],
          ["Teléfono", formatPhoneNumber(currentFormData.phone)],
          ["Estado civil", currentFormData.maritalStatus],
          ["Municipio", currentFormData.location],
          [
            "Ingreso",
            toNum(currentFormData?.income)
              ? `Mensual ${formatCurrency(toNum(currentFormData.income))}`
              : "Mensual N/A",
          ],
          ["Tipo de empleo", currentFormData.employmentType],
        ];

    return (
      <div
        style={{
          marginBottom: "2rem",
          border: "1px solid #ddd",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            backgroundColor: "#e0f7fa",
            padding: "12px",
            fontWeight: "bold",
            fontSize: "1.2rem",
          }}
        >
          {title}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
            padding: "16px",
            background: "#f9f9f9",
          }}
        >
          {fields.map(([label, value], index) => (
            <div
              key={index}
              style={{
                padding: "10px",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
            >
              <strong>{label}:</strong> <br />
              {value || "--"}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <main style={{ padding: "2rem", fontFamily: "Arial, sans-serif" }}>
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          background: "#fff",
          padding: "2rem",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        {loading ? (
          <p>Loading client data...</p>
        ) : !clientData ? (
          <p>Client not found.</p>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "0.5rem",
              }}
            >
              <h1 style={{ color: "#0096b2", margin: 0, fontSize: "2rem" }}>
                {currentFormData?.firstName || "Unnamed"}{" "}
                {currentFormData?.lastName || ""}
              </h1>
              <button
                onClick={handleRefresh}
                className="officer-refresh-btn"
                title="Refresh"
                aria-label="Refresh"
                style={{
                  background: "#0096b2",
                  color: "#fff",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  fontSize: "1.4em",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "1rem",
                  transition: "background 0.2s",
                }}
              >
                &#x21bb;
              </button>
            </div>
            {currentFormData?.creditScore && (
              <div
                style={{
                  fontWeight: 600,
                  color: "#1976d2",
                  marginBottom: "1em",
                  fontSize: "1.11em",
                }}
              >
                Credit Score: {currentFormData.creditScore}
              </div>
            )}
            <div style={{ display: "flex", gap: "12px", marginBottom: "1rem" }}>
              <a
                href={`https://wa.me/1${currentFormData?.phone?.replace(
                  /\D/g,
                  ""
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#25D366",
                  color: "white",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                WhatsApp
              </a>
              <a
                href={`mailto:${currentFormData?.email}`}
                style={{
                  backgroundColor: "#007bff",
                  color: "white",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Email
              </a>
            </div>
            {/* Calculator  */}
            <div>
              <img
                src="/assets/Calculator.png"
                alt="Summary"
                style={{ width: 48, height: 48, cursor: "pointer" }}
                onClick={() => setSummaryOpen(true)}
              />

              {summaryOpen && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(20,30,40,0.18)",
                    zIndex: 10000,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: 12,
                      minWidth: 340,
                      maxWidth: 580,
                      padding: "2rem",
                      boxShadow: "0 6px 40px #2225",
                      position: "relative",
                    }}
                  >
                    <button
                      style={{
                        position: "absolute",
                        right: 12,
                        top: 8,
                        fontSize: "1.7em",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => setSummaryOpen(false)}
                    >
                      ×
                    </button>
                    <h2 style={{ color: "#0096b2", marginBottom: 24 }}>
                      Resumen de la Solicitud
                    </h2>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 2fr",
                        gap: "0.5rem 1.25rem",
                        maxHeight: 340,
                        minHeight: 120,
                        overflow: "auto",
                        marginBottom: 18,
                        paddingRight: 4, // prevents scrollbar overlap
                      }}
                    >
                      {getAllFormSummaryFields(currentFormData).map(
                        ([label, value]) => (
                          <React.Fragment key={label}>
                            <div
                              style={{
                                fontWeight: 600,
                                color: "#045",
                                padding: "4px 0",
                              }}
                            >
                              {label}
                            </div>
                            <div style={{ color: "#222", padding: "4px 0" }}>
                              {value || "N/A"}
                            </div>
                          </React.Fragment>
                        )
                      )}
                    </div>
                    {clientData?.spouseFirstName && (
                      <>
                        <h3
                          style={{
                            color: "#0096b2",
                            marginTop: 18,
                            marginBottom: 10,
                          }}
                        >
                          Información del cónyuge
                        </h3>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginBottom: 18,
                          }}
                        >
                          <tbody>
                            {getSpouseSummaryFields(clientData).map(
                              ([label, value]) => (
                                <tr key={label}>
                                  <td style={{ fontWeight: 600, padding: 6 }}>
                                    {label}
                                  </td>
                                  <td style={{ padding: 6 }}>
                                    {value || "N/A"}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                marginBottom: "1rem",
                marginTop: "0.30rem",
                color: "#555",
              }}
            >
              {clientData.officerApproved
                ? `Revisado por: ${officerName}`
                : `En revisión por: ${officerName}`}
            </div>
            {renderSection(currentFormData, `${selectedView} Information`)}
            {currentFormData?.maritalStatus === "Married" &&
              currentFormData?.prenuptialAgreement !== "Yes" &&
              renderSection(currentFormData, "Spouse Information", true)}
            {selectedView === "Purchase" && clientData.preQualPDFs && (
              <div style={{ marginBottom: "1rem" }}>
                {clientData.preQualPDFs.FHA && (
                  <a
                    href={clientData.preQualPDFs.FHA}
                    download
                    style={{
                      marginRight: 8,
                      backgroundColor: "#00796b",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Download FHA PreQual PDF
                  </a>
                )}
                {clientData.preQualPDFs.USDA && (
                  <a
                    href={clientData.preQualPDFs.USDA}
                    download
                    style={{
                      marginRight: 8,
                      backgroundColor: "#388e3c",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Download USDA PreQual PDF
                  </a>
                )}
                {clientData.preQualPDFs.VA && (
                  <a
                    href={clientData.preQualPDFs.VA}
                    download
                    style={{
                      backgroundColor: "#1976d2",
                      color: "white",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    Download VA PreQual PDF
                  </a>
                )}
              </div>
            )}
            {selectedView === "Refinance" &&
              clientData.refinancePreQualPDFs && (
                <a
                  href={clientData.refinancePreQualPDFs.FHA}
                  download
                  style={{
                    display: "inline-block",
                    marginBottom: "1rem",
                    padding: "8px 16px",
                    backgroundColor: "#b28700",
                    color: "white",
                    borderRadius: "8px",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                >
                  Download Refinance PreQual PDF
                </a>
              )}
            {/* Qualification Summary */}
            {currentResult && (
              <div
                style={{
                  marginBottom: "2rem",
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#e0f7fa",
                    padding: "12px",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                  }}
                >
                  Resumen de Calificación
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "12px",
                    padding: "16px",
                    background: "#f9f9f9",
                  }}
                >
                  <div
                    style={{
                      padding: "10px",
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    <strong>Deudas totales:</strong>
                    <br />
                    {formatCurrency(currentResult.totalDebts)}
                  </div>

                  <div
                    style={{
                      padding: "10px",
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    <strong>Máximo FHA:</strong>
                    <br />
                    {formatCurrency(currentResult.pricing?.FHA || 0)}
                  </div>

                  <div
                    style={{
                      padding: "10px",
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    <strong>Máximo USDA:</strong>
                    <br />
                    {formatCurrency(currentResult.pricing?.USDA || 0)}
                  </div>

                  <div
                    style={{
                      padding: "10px",
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    <strong>Máximo VA:</strong>
                    <br />
                    {formatCurrency(currentResult.pricing?.VA || 0)}
                  </div>
                </div>
              </div>
            )}
            {clientData.officerApproved !== null &&
            clientData.officerApproved !== undefined ? (
              <div style={{ marginBottom: "1rem" }}>
                <div
                  style={{
                    fontWeight: "bold",
                    color: clientData.officerApproved ? "#2e7d32" : "#c62828",
                    background: clientData.officerApproved
                      ? "#e8f5e9"
                      : "#ffebee",
                    padding: "10px 16px",
                    borderRadius: 8,
                    display: "inline-block",
                    marginBottom: "0.5rem",
                  }}
                >
                  {clientData.officerApproved
                    ? "Precalificación aprobada"
                    : "Pendiente de aprobación"}
                  {clientData.officerReviewedAt &&
                    ` • ${new Date(
                      clientData.officerReviewedAt
                    ).toLocaleString()}`}
                </div>
                <br />
                <button
                  onClick={async () => {
                    const update = {
                      officerApproved: null,
                      officerReviewedAt: null,
                    };
                    if (clientData?.formDataPurchase) {
                      update.purchasePreQualApproved = null;
                    }
                    if (clientData?.formDataRefinance) {
                      update.refinancePreQualApproved = null;
                    }
                    await updateDoc(doc(db, "clients", clientId), update);
                    setClientData({ ...clientData, ...update });
                  }}
                  style={{
                    backgroundColor: "#fbc02d",
                    color: "black",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Revisión
                </button>
              </div>
            ) : (
              <div style={{ marginBottom: "1rem" }}>
                <button
                  onClick={async () => {
                    const update = {
                      officerApproved: true,
                      officerReviewedAt: new Date().toISOString(),
                    };
                    if (clientData?.formDataPurchase) {
                      update.purchasePreQualApproved = true;
                    }
                    if (clientData?.formDataRefinance) {
                      update.refinancePreQualApproved = true;
                    }
                    await updateDoc(doc(db, "clients", clientId), update);
                    setClientData({ ...clientData, ...update });
                  }}
                  style={{
                    marginRight: "1rem",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Aprobar
                </button>
              </div>
            )}
            {/* Officer note section */}
            <div style={{ marginBottom: "1rem" }}>
              <textarea
                rows={3}
                placeholder="Send note to client Dashboard..."
                value={noteToClient}
                onChange={(e) => setNoteToClient(e.target.value)}
                style={{
                  width: "100%",
                  borderRadius: 8,
                  border: "1px solid #0096b2",
                  padding: 8,
                }}
              />
              <button
                onClick={async () => {
                  await updateDoc(doc(db, "clients", clientId), {
                    lastNoteToClient: noteToClient,
                    lastContactedAt: new Date().toISOString(),
                  });
                  alert("Note sent to client!");
                  setClientData({
                    ...clientData,
                    lastNoteToClient: noteToClient,
                    lastContactedAt: new Date().toISOString(),
                  });
                }}
                style={{
                  backgroundColor: "#0096b2",
                  color: "white",
                  padding: "6px 20px",
                  borderRadius: 8,
                  marginTop: 4,
                  border: "none",
                }}
              >
                Enviar mensaje a cliente
              </button>
            </div>
            <button
              onClick={handleBack}
              style={{
                marginTop: "1rem",
                backgroundColor: "#555",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Volver al panel
            </button>
            <button
              onClick={() =>
                setSelectedView(
                  selectedView === "Purchase" ? "Refinance" : "Purchase"
                )
              }
              style={{
                position: "absolute",
                bottom: "16px",
                right: "16px",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                backgroundColor: "#0096b2",
                color: "white",
                border: "none",
                fontWeight: "bold",
                fontSize: "0.9rem",
                cursor: "pointer",
                textAlign: "center",
                padding: "10px",
              }}
            >
              {selectedView === "Purchase"
                ? "View\nRefinance Info"
                : "View\nPurchase Info"}
            </button>
          </>
        )}
      </div>
    </main>
  );
}
